module.exports = __webpack_public_path__ + "assets/img/letter.00acd483.png";